/**
 * Guarda o access token só em memória (nunca em localStorage) — sobrevive enquanto a aba está
 * aberta; o refresh token de longa duração vive num cookie httpOnly que o browser já manda
 * sozinho. Um store por domínio de auth (staff / portal), já que os JWTs não se misturam.
 */
export function createTokenStore() {
  let token: string | null = null;
  return {
    get: () => token,
    set: (t: string | null) => {
      token = t;
    },
  };
}

export type TokenStore = ReturnType<typeof createTokenStore>;

export const staffTokenStore = createTokenStore();
export const portalTokenStore = createTokenStore();
